module.exports = __webpack_public_path__ + "static/img/home_new12.89a44d9f.jpg";